<template>
  <div id="contents">
    <div class="recruit_movie" v-if="movie_post">
      <div class="recruit_movie_main">
        <div class="title_area">
           <p :class="[movie_post.title_layout_type === 1 ? 'title_layout_1' : 'title_layout_2']" v-for="title in movie_post.title" :key="title.id">{{ title.text }}</p>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <p class="recruit_caption" v-if="movie_post.title_layout_type === 1" v-html="movie_post.caption" :style="{'margin': 81 + 'px' + ' 5.6vw' + ' 0'}" >
        <p class="direct_caption" v-else v-html="movie_post.caption" :style="{'margin': 'calc( ' + 10.9 * movie_post.title.length + 'vw' + ' - 41px )' + ' 5.6vw' + ' 0'}" >
        </p>
        <video autoplay controls muted playsinline :class="[movie_post.title_layout_type === 1 ? 'video_long_type' : 'video_wide_type']">
          <source :src="[ this.video_base_url + movie_post.movie]" type="video/mp4">
        </video>
        <template v-if="movie_post.producer_layout_type === 1">
          <div class="producer_title recruit_movie_color">
            <p>制作者コメント</p>
          </div>
          <div class="producer_layout1" v-for="producer in movie_post.producer" :key="producer.id">
            <div class="thumbnail">
              <img :src="producer.image">
            </div>
            <div class="text_area">
              <p class="info" v-for="info in producer.info" :key="info.id">{{ info.text }}</p>
              <h4>{{ producer.name }}</h4><p class="name_en">{{producer.name_en}}</p>
              <div class="pink_line"></div>
              <p class="text" v-html="producer.text"></p>
            </div>
          </div>
        </template>
        <template v-if="movie_post.producer_layout_type === 2">
          <div class="producer_title direct_movie_color">
            <p>制作者コメント</p>
          </div>
          <div class="producer_layout2" v-for="producer in movie_post.producer" :key="producer.id">
            <div class="thumbnail">
              <img :src="producer.image">
            </div>
            <div class="text_area">
              <p class="info">{{ producer.info }}</p>
              <h4>{{ producer.name }}</h4><p class="name_en">{{producer.name_en}}</p>
              <div class="comment">
                <div class="pink_line"></div>
                <p class="text" v-html="producer.text"></p>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="relation_movie_list" >
        <div class="title">
          <h4>関連ムービー</h4>
        </div>
        <slick ref="slick" :options="slick_options" id="relation_movie_slider" v-if="movie_post">
          <li v-for="relation_movie in movie_post.relation_movie" :key="relation_movie.id" @click="reload_model(relation_movie.movie_id, 'movie')">
            <div class="thumbnail">
              <img :src="relation_movie.thumbnail" >
            </div>
            <div v-if="relation_movie.title_layout_type == 1" >
              <p class="direct_movie_title">{{ relation_movie.title }}</p>
            </div>
            <div v-else-if="relation_movie.title_layout_type == 2">
              <p class="recruit_movie_title" v-html="relation_movie.title"></p>
            </div>
          </li>
        </slick>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
import movie_post_list from './js/recruit_movie.json'
import Slick from 'vue-slick';
export default {
  name: 'recruit_movie',
  data() {
    return {
      video_base_url: '../sp/static/recruit_2021',
      movie_post_list: movie_post_list,
      movie_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
      slick_options: {
        autoplay:true,
        autoplaySpeed:5000,
        dots:true,
      }
    }
  },
  props: [
    'post_type'
  ],
  components: {
    Slick
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    this.fetch_movie_post(this.$route.params.id)
    if( window.location.protocol + '//' + window.location.host == "https://www.tv-asahipro.co.jp" ){
      this.video_base_url = "https://www.tv-asahipro.co.jp/recruit2021/sp"
    } else if ( window.location.protocol + '//' + window.location.host == "http://vivia.stg-malk.com" ){
      this.video_base_url = "http://vivia.stg-malk.com/recruit2021/sp"
    } else {
    }
  },
  methods: {
    fetch_movie_post(request_id){
      this.movie_post = this.movie_post_list[request_id]
      setTimeout(() => {
        this.add_css_to_slider()
      }, 200);
    },
    reload_model(post_id, layout) {
      var post = this.movie_post_list.find(post => post.id == post_id);
      if (post != null){
        this.$emit('reload_model', post_id, layout);
      }
    },
    close(){
      this.$emit('close_icon');
    },
    add_css_to_slider(){
      $("#relation_movie_slider").addClass('slider');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw
  .recruit_movie
    &_main
      width: 90.4vw
      margin: calc(36.1vw - 41px) auto 0
      padding-bottom: 8.5vw
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -25px
        left: 21px
        .title_layout_1
          @include recruit_font(25px, 25px, .043em)
          color: #fff
          background: #3785E0
          padding: 11px 3px 13px 9px
          display: table
          &:nth-child(even)
            @include recruit_font(25px, 25px, .043em)
            padding: 5px 10px 6px 9px
          &:last-child
            @include recruit_font(23px, 25px, .043em)
            padding: 12px 10px 13px 9px !important
        .title_layout_2
          @include recruit_font(6.9vw, 6.9vw, 1.5vw)
          color: #fff
          background: #02ACC3
          padding: 9px 3px 9px 9px
          display: table
          &:nth-child(even)
            @include recruit_font(6.9vw, 6.9vw, 1.5vw)
            padding: 4px 5px 4px 9px
          &:last-child
            @include recruit_font(6.9vw, 6.9vw, 1.2vw)
            padding: 4px 9px 10px 9px !important
      .direct_caption
        @include recruit_font(12px, 23px, .196em)
        display: inline-block
      .recruit_caption
        @include recruit_font(12px, 23px, .172em)
        display: inline-block
      .back_btn_icon
        position: absolute
        top: -78px
        left: 0vw
        img
          width: 32px
          height: 32px
      video
        &.video_long_type
          width: 289px
          height: 515px
          margin: 23px 6.7vw 32px
        &.video_wide_type
          width: 78.7vw
          height: 44.3vw
          margin: 9.3vw 6.1vw 10.4vw 5.6vw
      .producer
        &_title
          width: 79.2vw
          margin: 0 auto
          margin-bottom: 6.9vw
          text-align: center
          p
            @include recruit_font(4vw, 12.3vw, 0.5vw)
            color: #fff
          &.direct_movie_color
            background-color: #02ACC3
          &.recruit_movie_color
            background-color: #3785E0
        &_layout1
          width: 79.2vw
          margin: 0 auto
          margin-top: 59px
          &:not(:first-child)
            margin-top: 25px
          .thumbnail
            width: 131px
            height: 131px
            img
              width: 131px
              height: 131px
          .text_area
            .info
              @include recruit_font(12px, 18px, .126em)
              margin: 0px
              color: #FF7689
              &:first-child
                margin: 14px 0 0
            h4
              @include recruit_font(22px, 22px, .206em)
              color: #FF7689
              margin: 12px 0 17px 0
              float: left
            .name_en
              @include recruit_font(16px, 22px, .066em)
              color: #FF7689
              margin: 12px 0 17px 8px
              display: inline-block
              vertical-align: top
            .pink_line
              height: 3px
              width: 99%
              background-image: url("../assets/img/common/recruit_2021/pink_line.svg")
              display: block
              line-height: 0
              vertical-align: bottom
              top: -14px
            .text
              @include recruit_font(12px, 23px, .107em)
              margin-top: 17px
        &_layout2
          width: 79.2vw
          margin: 0 auto
          .thumbnail
            width: 34.9vw
            height: 34.9vw
            img
              width: 34.9vw
              height: 34.9vw
          .text_area
            .info
              @include recruit_font(12px, 18px, 1px)
              margin: 14px 0 7px
              color: #FF7689
            h4
              @include recruit_font(22px, 22px, 4px)
              color: #FF7689
              float: left
            .name_en
              @include recruit_font(16px, 16px, 1px)
              color: #FF7689
              margin: 3px 0 0 8px
              display: inline-block
              vertical-align: top
            .comment
              position: relative
              margin-top: 26px
              .pink_line
                height: 3px
                width: 100%
                background-image: url("../assets/img/common/recruit_2021/pink_line.svg")
                vertical-align: bottom
                position: absolute
                top: -14px
            .text
              @include recruit_font(12px, 23px, 1px)
    .relation_movie_list
      width: 90.4vw
      height: 325px
      margin: 0 auto
      margin-top: 10.4vw
      margin-bottom: 0px
      padding-bottom: 104px
      .title
        width: 46.4vw
        background-color: #fff
        h4
          @include recruit_font(5.6vw, 9.6vw, 0.8vw)
          color: #FF7689
          margin: 0 1.7vw 0 0.9vw
          text-align: center
      .slider
        margin-top: 17px !important

  @media screen and (max-width: 374px)
    #contents
    .recruit_movie
      &_main
        margin: 80px auto 0
        padding-bottom: 8.5vw
        .title_area
          left: 3.8vw
          .title_layout_1
            @include recruit_font(20px, 20px, .043em)
            color: #fff
            background: #3785E0
            padding: 8px 3px 11px 9px
            display: table
            &:nth-child(even)
              @include recruit_font(20px, 20px, .043em)
              padding: 2px 10px 4px 9px
            &:last-child
              @include recruit_font(20px, 20px, .043em)
              padding: 9px 10px 11px 9px !important
        .title
          @include recruit_font(24px, 24px, 4px)
          padding: 9px 3px 9px 9px
          &:nth-child(even)
            @include recruit_font(26px, 26px, 2px)
            padding: 4px 5px 4px 9px
          &:last-child
            padding: 7px 2px 7px 9px !important
        .caption
          @include recruit_font(12px, 23px, 1.5px)
          margin: 50px 5.6vw 10px !important
        .back_btn_icon
          top:  -78px
          left: 0vw
          img
        video
          &.video_long_type
            width: 77.1vw
            height: 137.3vw
            margin: 2.4vw 6.7vw 11.5vw
          &.video_wide_type
            width: 78.7vw
            height: 44.3vw
            margin: 9.3vw 6.1vw 10.4vw 5.6vw
        .producer
          &_title
            margin-bottom: 6.9vw
            p
          &_layout1
            width: 79.2vw
            margin-top: 59px
            &:not(:first-child)
              margin-top: 25px
            .thumbnail
              width: 126px
              height: 126px
              img
                width: 126px
                height: 126px
            .text_area
              .info
                font-size: 10px
              .pink_line
                width: 100%
          &_layout2
            .thumbnail
              img
            .text_area
              .info
                @include recruit_font(3.2vw, 3.2vw, 0.1vw)
                margin: 3.7vw 0 2.7vw
                color: #FF7689
              h4
                @include recruit_font(5.9vw, 5.9vw, 0.3vw)
              .name_en
                @include recruit_font(4.3vw, 5.9vw, 0.1vw)
              .comment
                margin-top: 5vw
                .pink_line
                  margin: 0vw 0 0vw
                  height: 3px
                  width: 79.2vw
                  top: -3.3vw
                  vertical-align: bottom
              .text
      .relation_movie_list
        .title
          h4
        .slider
          .slick-prev
            &:before
          .slick-next
            &:before
          .slick-dots
            .slick-active
              button
                &:before
            li
              button
                &:before
          li
            .thumbnail
              img
            p
              &.recruit_movie_title
                font-size: 12px
</style>

<style>
  .slider
  {
    margin-top: 17px !important;
  }
  .slider .slick-prev
  {
    left: 21.5vw !important;
    bottom: -50px !important;
    top: unset !important;
  }
  .slider .slick-prev:before
  {
    background-image: url('../assets/img/common/recruit_2021/prev_arrow.svg') !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    font-family: none !important;
    color: unset !important;
    opacity: 1 !important;
    font-size: 17px !important;
  }
  .slider .slick-next
  {
    right: 19.5vw !important;
    bottom: -50px !important;
    top: unset !important;
  }
  .slider .slick-next:before
  {
    background-image: url('../assets/img/common/recruit_2021/next_arrow.svg') !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    font-family: none !important;
    color: unset !important;
    opacity: 1 !important;
    font-size: 17px !important;
  }
  .slider .slick-dots
  {
    width: 41% !important;
    margin: 0 calc(59% / 2) !important;
    line-height: 10px !important;
    bottom: -44px !important;
    display: flex !important;
    justify-content: space-around !important;
  }
  .slider .slick-dots .slick-active button:before
  {
    color: #FFBA00 !important;
    opacity: 1 !important;
    width: 100% !important;
  }
  .slider .slick-dots li
  {
    width: 23px !important;
    height: 23px !important;
    margin: 0 !important;
  }
  .slider .slick-dots li button:before
  {
    color: #FFF !important;
    opacity: 1 !important;
  }
  .slider li .thumbnail
  {
    width: 90.4vw !important;
    height: 50.9vw !important;
    background-color: #D8D8D8 !important;
    overflow: hidden !important;
  }
  .slider li .thumbnail img
  {
    width: 101% !important;
  }
  .slider li .direct_movie_title
  {
    font-family: 'Noto Sans JP', sans-serif !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    line-height: 31px !important;
    letter-spacing: 0.176em !important;
    color: #fff !important;
    margin-top: 6px !important;
    margin-bottom: 2px !important;
    text-align: center !important;
  }
  .slider li .recruit_movie_title
  {
    margin-top: 9px !important;
    font-family: 'Noto Sans JP', sans-serif !important;
    font-weight: 700 !important;
    font-size: 13px !important;
    line-height: 19px !important;
    letter-spacing: 0.176em !important;
    color: #fff !important;
    text-align: center !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/recruit_movie.vue